import { Modal, Button } from "react-bootstrap";
import { confirmable, createConfirmation } from "../../utils/confirm";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import { useAuth } from "../../hooks/useAuth";
import ModalLoader from "./ModalLoader";

function BranchPicker({ proceed, show, company, showLoader = false }) {
  const { user: authUser, logout } = useAuth();
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const { mutate, isLoading } = useMutation(
    async () => {
      const response = await fetch(
        `${company.url}/api/branch/get-branches-by-staff?Staff_ID=${
          authUser.Staff_ID
        }`,
        {
          method: "GET",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          credentials: "include",
        }
      );
      if (!response.ok) throw new Error("Unable to fetch branches");
      return response.json();
    },
    {
      onSuccess: ({ data: { branches: fetchedBranches = [] } }) => {
        if (fetchedBranches.length === 1) {
          proceed(fetchedBranches[0].branchId);
        } else if (fetchedBranches.length === 0) {
          //  toast.info("You are not assigned to any branch");
          proceed(null);
        } else {
          // >1 branches — show picker modal
          setBranches(fetchedBranches);
        }
      },
      onError: () => {
        toast.error("Unable to switch company, Please try again");
        logout();
        proceed(null);
      },
    }
  );

  useEffect(() => {
    mutate();
  }, []);

  if (isLoading && showLoader) return <ModalLoader show={true} />;

  if (branches.length === 0) return null;

  const options = branches.map(b => ({ label: b.name, value: b.id }));

  return (
    <Modal
      show={show}
      centered
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>
          <h1 className="h6 m-0">Select Branch</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          You have access to multiple branches in this company. Please select
          one to continue.
        </p>
        <Select
          options={options}
          value={options.find(o => o.value === selectedBranch) || null}
          onChange={opt => setSelectedBranch(opt?.value ?? null)}
          placeholder="Select a branch..."
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="px-4"
          disabled={!selectedBranch}
          onClick={() => proceed(selectedBranch)}
        >
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default function BranchInCompanyPicker(props) {
  return createConfirmation(confirmable(BranchPicker))(props);
}
